import React from 'react';

export default ({ size }) => (
<svg version="1.1" x="0px" y="0px"
	 width={size} height={size} viewBox="0 0 63.904 64.438" enableBackground="new 0 0 63.904 64.438">
<g id="Layer_1">
	<circle fill="#FFFFFF" stroke="#5C3AED" strokeWidth="2" strokeMiterlimit="10" cx="31.648" cy="31.648" r="29.648"/>
	<circle fill="#D6CFFC" cx="31.647" cy="31.648" r="26.55"/>
	<g id="Oval_1_">
		<circle fill="#5C3AED" cx="10.077" cy="90.653" r="4.043"/>
		<path fill="#5C3AED" d="M10.077,95.63c-2.746,0-4.979-2.232-4.979-4.979c0-2.743,2.233-4.977,4.979-4.977
			c2.743,0,4.977,2.232,4.977,4.977C15.053,93.397,12.82,95.63,10.077,95.63z M10.077,87.545c-1.715,0-3.108,1.395-3.108,3.106
			c0,1.713,1.394,3.108,3.108,3.108c1.713,0,3.105-1.396,3.105-3.108C13.182,88.94,11.79,87.545,10.077,87.545z"/>
	</g>
	<g id="Oval_2_">
		<path fill="#5C3AED" d="M127.34,11.956c-2.745,0-4.979-2.232-4.979-4.979c0-2.743,2.233-4.978,4.979-4.978
			c2.744,0,4.978,2.233,4.978,4.978C132.317,9.723,130.084,11.956,127.34,11.956z M127.34,3.87c-1.714,0-3.107,1.396-3.107,3.107
			c0,1.715,1.394,3.107,3.107,3.107c1.713,0,3.107-1.394,3.107-3.107C130.447,5.265,129.053,3.87,127.34,3.87z"/>
	</g>
	<g id="Shape">
		<rect x="20.695" y="69.743" fill="#5C3AED" width="1.871" height="5.257"/>
	</g>
	<g id="Shape_1_">
		
			<rect x="31.599" y="95.679" transform="matrix(-0.5389 -0.8423 0.8423 -0.5389 -32.9018 178.9876)" fill="#5C3AED" width="1.87" height="5.638"/>
	</g>
	<g id="Shape_2_">
		
			<rect x="0.059" y="80.34" transform="matrix(-0.8423 -0.5389 0.5389 -0.8423 -38.4998 151.2891)" fill="#5C3AED" width="5.639" height="1.871"/>
	</g>
	<g id="Oval_5_">
		<circle fill="#5C3AED" cx="54.811" cy="71.437" r="4.043"/>
		<path fill="#5C3AED" d="M54.811,76.414c-2.744,0-4.977-2.232-4.977-4.978s2.232-4.978,4.977-4.978
			c2.747,0,4.979,2.231,4.979,4.978C59.791,74.182,57.558,76.414,54.811,76.414z M54.811,68.329c-1.713,0-3.105,1.396-3.105,3.107
			c0,1.714,1.394,3.107,3.105,3.107c1.714,0,3.108-1.395,3.108-3.107C57.92,69.725,56.526,68.329,54.811,68.329z"/>
	</g>
	<g id="Oval_6_">
		<path fill="#5C3AED" d="M99.494,91.94c-2.745,0-4.978-2.231-4.978-4.977c0-2.747,2.232-4.978,4.978-4.978
			c2.744,0,4.978,2.229,4.978,4.978C104.471,89.708,102.238,91.94,99.494,91.94z M99.494,83.855c-1.713,0-3.107,1.396-3.107,3.108
			s1.395,3.105,3.107,3.105s3.108-1.394,3.108-3.105S101.207,83.855,99.494,83.855z"/>
	</g>
	<g id="Oval_7_">
		<circle fill="#FFFFFF" cx="106.925" cy="67.394" r="4.043"/>
		<path fill="#5C3AED" d="M106.925,72.371c-2.745,0-4.979-2.232-4.979-4.978s2.233-4.978,4.979-4.978s4.978,2.231,4.978,4.978
			C111.902,70.139,109.67,72.371,106.925,72.371z M106.925,64.286c-1.713,0-3.108,1.396-3.108,3.107
			c0,1.714,1.396,3.107,3.108,3.107s3.107-1.395,3.107-3.107C110.032,65.682,108.637,64.286,106.925,64.286z"/>
	</g>
	<g id="Shape_3_">
		<rect x="129.343" y="73.713" fill="#5C3AED" width="1.871" height="5.256"/>
	</g>
	<g id="Shape_4_">
		
			<rect x="143.448" y="13.19" transform="matrix(-0.5387 -0.8425 0.8425 -0.5387 208.674 146.2764)" fill="#5C3AED" width="1.871" height="5.639"/>
	</g>
	<g id="Shape_5_">
		
			<rect x="41.608" y="78.034" transform="matrix(-0.8425 -0.5388 0.5388 -0.8425 39.3087 169.4326)" fill="#5C3AED" width="5.637" height="1.871"/>
	</g>
</g>
<g id="Layer_2" display="none">
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="16.551" y1="41.428" x2="39.451" y2="41.428"/>
	<g display="inline">
		<defs>
			<circle id="SVGID_1_" cx="31.647" cy="31.648" r="26.55"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use overflow="visible"/>
		</clipPath>
		<path opacity="0.7" clipPath="url(#SVGID_2_)" fill="#5C3AED" d="M51.775,59.416c0,1.656-1.344,3-3,3H22.049
			c-1.656,0-3-1.344-3-3V20.424c0-1.657,1.344-3,3-3h26.726c1.656,0,3,1.343,3,3V59.416z"/>
		<g clipPath="url(#SVGID_2_)">
			<path fill="#FFFFFF" d="M44.427,66.743c0,1.656-1.344,3-3,3H14.702c-1.656,0-3-1.344-3-3V27.751c0-1.657,1.344-3,3-3h26.725
				c1.656,0,3,1.343,3,3V66.743z"/>
			<path fill="#5C3AED" d="M41.427,70.493H14.702c-2.068,0-3.75-1.683-3.75-3.75V27.751c0-2.068,1.682-3.75,3.75-3.75h26.725
				c2.067,0,3.75,1.682,3.75,3.75v38.992C45.177,68.811,43.494,70.493,41.427,70.493z M14.702,25.501c-1.241,0-2.25,1.009-2.25,2.25
				v38.992c0,1.24,1.009,2.25,2.25,2.25h26.725c1.24,0,2.25-1.01,2.25-2.25V27.751c0-1.241-1.01-2.25-2.25-2.25H14.702z"/>
		</g>
	</g>
</g>
<g id="Layer_3" display="none">
	<polyline display="inline" fill="#FFFFFF" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" points="16.675,29.866 
		20.407,33.6 17.216,36.79 16.551,37.456 	"/>
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="24.703" y1="33.536" x2="37.202" y2="33.536"/>
	<g id="Oval_4_" display="inline">
		<circle fill="#FFFFFF" cx="41.549" cy="29.011" r="7.833"/>
		<path fill="#5C3AED" d="M41.549,37.777c-4.834,0-8.768-3.932-8.768-8.768c0-4.834,3.934-8.766,8.768-8.766
			s8.767,3.932,8.767,8.766C50.315,33.845,46.383,37.777,41.549,37.777z M41.549,22.114c-3.803,0-6.896,3.093-6.896,6.896
			c0,3.804,3.094,6.897,6.896,6.897s6.896-3.095,6.896-6.897S45.351,22.114,41.549,22.114z"/>
	</g>
	<polyline display="inline" fill="none" stroke="#5C3AED" strokeWidth="2" strokeMiterlimit="10" points="37.69,29.397 
		40.004,31.711 45.405,26.311 	"/>
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="16.317" y1="42.428" x2="40.451" y2="42.428"/>
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="16.317" y1="48.219" x2="26.702" y2="48.219"/>
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="11.702" y1="42.428" x2="11.702" y2="53.583"/>
	
		<line display="inline" fill="none" stroke="#5C3AED" strokeWidth="1.5" strokeMiterlimit="10" x1="44.369" y1="50.719" x2="44.369" y2="58.745"/>
</g>
<g id="Layer_4">
</g>
<g id="Layer_5">
	<circle fill="#FFFFFF" stroke="#5C3AED" strokeWidth="2" strokeMiterlimit="10" cx="28.853" cy="28.776" r="15.827"/>
	<line fill="none" stroke="#5C3AED" strokeWidth="3" strokeMiterlimit="10" x1="40.258" y1="39.744" x2="50.242" y2="49.73"/>
	<line fill="none" stroke="#5C3AED" strokeWidth="7" strokeMiterlimit="10" x1="43.209" y1="43.289" x2="50.267" y2="50.348"/>
	<g>
		<polygon fill="#5C3AED" points="23.508,35.585 16.904,28.983 23.859,22.029 25.316,23.486 19.818,28.983 24.965,34.128 		"/>
	</g>
	<g>
		<polygon fill="#5C3AED" points="33.849,35.585 32.392,34.128 37.89,28.63 32.744,23.486 34.201,22.029 40.804,28.63 		"/>
	</g>
	<g>
		
			<rect x="27.407" y="18.305" transform="matrix(-0.9631 -0.2692 0.2692 -0.9631 48.0767 64.1472)" fill="#5C3AED" width="2.06" height="20.944"/>
	</g>
</g>
</svg>
)
